module.exports = __webpack_public_path__ + "img/window-flip.3caa4e6d.svg";